import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgArrowUp = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M2.529 7.471a.748.748 0 0 0 1.057 1.058L7.25 4.872v8.378a.75.75 0 0 0 1.5 0V4.872l3.653 3.66a.753.753 0 1 0 1.065-1.064L8 2z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowUp);
export default ForwardRef;
